"use strict";
'app public';

// Corps de message (bodyTemplate) affiché à la place de l'erreur anglaise
// « You must have a registered nick (+r)… » sur un salon +r. Le lien « Clique ici »
// ouvre le modal d'enregistrement NickServ (exposé par plugin-nickserv via
// window.app.pluginNickserv.nsregisterdialog), stylé en modal par theme.css
// (.app-main-mediaviewer:has(.app-ns-button)).
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: {
    channel: {
      type: String,
      default: ''
    },
    // Props injectées par le rendu bodyTemplate (déclarées pour éviter les
    // warnings d'attributs ; non utilisées ici).
    message: {
      type: Object,
      default: null
    },
    buffer: {
      type: Object,
      default: null
    },
    ml: {
      type: Object,
      default: null
    },
    idx: {
      type: Number,
      default: 0
    }
  },
  methods: {
    openRegister() {
      const app = window.app;
      const ns = app && app.pluginNickserv;
      if (ns && ns.nsregisterdialog && app.state) {
        app.state.$emit('mediaviewer.show', {
          component: ns.nsregisterdialog
        });
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["NsRegisterPrompt"]
window._app_exports.components.NsRegisterPrompt = exports.default ? exports.default : exports;
